import { mainHubLoader } from './mainhub.loader';
import { sportRoomLoader } from './sportRoom.loader';
import { appManagerLoader } from './appManager.loader';
export const loaders = {
    mainHubLoader,
    sportRoomLoader,
    appManagerLoader
};